export const exportToCSV = (response: any, exportFileName: string) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', exportFileName);
  document.body.appendChild(link);
  link.click();
};
